import React, { useState } from "react";
import "./Nav.css";

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  return (
    <div className="navbar">
      <div className="title">Antonio.dev</div>

      <div
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
        <li onClick={() => scrollToSection("home")}>Home</li>
        <li onClick={() => scrollToSection("experience")}>Experience</li>
        <li onClick={() => scrollToSection("skills")}>Skills</li>
        <li onClick={() => scrollToSection("about")}>About Me</li>

        <a
          href="mailto:antojunioralfa77@gmail.com"
          className="nav-connect-mobile"
        >
          Let's Connect!
        </a>
      </ul>

      <a
        href="mailto:antojunioralfa77@gmail.com"
        className="nav-connect"
      >
        Let's Connect!
      </a>
    </div>
  );
};

export default Nav;